<template>
  <div class="show-select-info-coin">













    <table>
      <tr>
        <th class="first">قیمت لحظه ایی</th>
        <th>بیشترین قیمت</th>
        <th>کمترین قیمت</th>
        <th>تغییرات 24h</th>
        <th class="last mobile">حجم بازار</th>
      </tr>

      <tr>
        <td class="number first">
          {{ $toLocal(data.lastPrice, precision) }}
        </td>
        <td class="number green">
          {{ $toLocal(data.maxPrice, precision) }}
        </td>
        <td class="number red">
          {{ $toLocal(data.minPrice, precision) }}
        </td>
        <td
          class="number"
          :class="{
            red: data.last24HourChange < 0,
            green: data.last24HourChange >= 0,
          }"
        >
          {{ $toLocal(data.last24HourChange, precision) }}
        </td>
        <td class="number last mobile">
          {{ $toLocal(data.last24HourVolume, precision) }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import {
  Loop,
  tradeTo,
  tradeFrom,
  precision,
} from "../../../lib/reuseableFunction";

export default {
  name: "show-select-info-coin",
props:['data'],

  computed: {
    tradeFrom,
    tradeTo,
    precision,
  },



};
</script>

<style lang="scss" scoped>
.show-select-info-coin {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 20px;

  table {
    table-layout: fixed;
    width: 100%;

    .last {
      text-align: left !important;
    }

    .first {
      text-align: right !important;
    }

    th {
      color: rgba(215, 200, 200, 1);
      font-size: clamp(8px, 2vw, 12px);
      text-align: center;
    }

    td {
      font-size: clamp(10px, 2vw, 15px);
      text-align: center;
      font-weight: 700;
    }
  }
}

@media (max-width: 600px) {
  .show-select-info-coin {
    margin-top: 30px;
  }

  @media (max-width: 400px) {
.mobile{
  display: none;
}
  }
}
</style>
